const features = [
  {
    title: "Schedule Theme Publishes",
    desc: "Select any installed or unpublished theme, choose the exact date and time, and Schedulify will automatically publish it for you — no manual switching, no late-night logins, and no stress.",
    icon: "images/Feature-img-01.svg",
  },
  {
    title: "Automatic Revert or Chaining",
    desc: "Set your theme to automatically revert back to a previous theme after the campaign ends, or chain multiple themes in sequence for pre-launch, launch, and post-launch experiences all hands-free.",
    icon: "images/Feature-img-02.svg",
  },
  {
    title: "Plan Ahead",
    desc: "Plan your theme updates days, weeks, or even months in advance. Whether it’s a holiday sale, new collection drop, or seasonal campaign, your store stays perfectly timed and consistent.",
    icon: "images/Feature-img-03.svg",
  },
  {
    title: "Perfect for Campaigns",
    desc: "Ensure your storefront always matches your promotions. Schedule theme changes to align with flash sales, influencer campaigns, ad launches, and major events with zero manual intervention.",
    icon: "images/Feature-img-04.svg",
  },
  {
    title: "Timezone Accurate",
    desc: "Every scheduled publish is synced to your store’s timezone, guaranteeing your theme updates exactly when intended no more confusion or mismatched publish times across regions.",
    icon: "images/Feature-img-05.svg",
  },
];
export default features;
